import { ReactElement } from 'react';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material';

import Header from '@app/layouts/admin/components/header/Header';

interface MainPageLayoutProps {
  children: ReactElement;
  className?: string;
}

function AdminLayoutFullWidth({ children }: MainPageLayoutProps) {
  return (
    <LayoutWrapper spacing={2}>
      <Header />
      <Container maxWidth='xl' sx={{ overflow: 'auto', justifySelf: 'center' }}>
        {children}
      </Container>
    </LayoutWrapper>
  );
}

const LayoutWrapper = styled(Stack)`
  display: grid;
  grid-template-rows: max-content 1fr;
  height: 100%;
`;

export default AdminLayoutFullWidth;
